import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Apis } from '../../core/apis';
import { environment } from '../../environments/environment';
import { GenericListResponse } from '../../models/generic-list-response';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { BehaviorSubject, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { TokenAndRefreshToken } from '../../models/tokenandrefreshtoken.model';

const API_FOR_TRANSACTION_LIST_URL = Apis.getTransactions;
const API_FOR_TRANSACTIONS_BY_ID_URL = Apis.getTransactionById;
const API_ESTIMATE_FOR_TRANSACTION_URL = Apis.getEstimateForTransaction;
const API_INGRESS_COUNTRIES_FOR_TRANSACTION_URL =
  Apis.getIngressCountriesForTransaction;
const API_EGRESS_COUNTRIES_FOR_TRANSACTION_URL =
  Apis.getEgressCountriesForTransaction;
const API_INGRESS_CURRENCIES_FOR_TRANSACTION_URL =
  Apis.getIngressCurrenciesForTransaction;
const API_EGRESS_CURRENCIES_FOR_TRANSACTION_URL =
  Apis.getEgressCurrenciesForTransaction;
const API_PAYOUT_OPTION_FOR_TRANSACTION_URL =
  Apis.getPayoutOptionForTransaction;
const API_PAYMENT_OPTION_FOR_TRANSACTION_URL =
  Apis.getPaymentOptionForTransaction;
const API_FOR_CREATE_TRANSACTION_URL = Apis.createTransaction;
const API_FOR_CUSTOMER_BY_ID_URL = Apis.getCountryByCustomerId;
const API_FOR_TRANSACTION_STEPS_BY_TRANSACTION_ID_URL =
  Apis.getTransactionStepsByTransactionId;
const API_FOR_ACTION_FOR_TRANSACTION_URL = Apis.getActionForTransaction;
const API_FOR_LINK_FOR_LIVENESS_URL = Apis.getLinkForLiveness;
const API_FOR_INIT_SANCTION_CHECK_URL = Apis.initSanctionCheck;
const API_FOR_INIT_PAYMENT_URL = Apis.paymentInit;
const API_FOR_PAYMENT_DONE_URL = Apis.paymentDone;
const API_FOR_PROCESSED_TO_PAYOUT_INPROGRESS_URL =
  Apis.processedToPayoutInProgress;
const API_FOR_PROCESSED_TO_PAYOUT_COMPLETE_URL = Apis.processedToPayoutComplete;
const API_FOR_PUBLIC_URL_TRANSACTION_DOCUMENT = Apis.transactionDocument;
const API_FOR_PURPOSES_URL = Apis.getPurpose;
const API_FOR_SAR_TRANSACTION_BY_ID_URL = Apis.SARTransactionByTransactionId;
const API_FOR_SKIP_LIVENESS_URL = Apis.skipLiveness;
const API_FOR_TRANSACTION_MISC_VAR_SHAREABLE_LINK =
  Apis.getSharableLinkForTransactionMiscVars;
const API_FOR_TRANSACTION_PAYOUT_SCHEMA_VALUE_OPTION =
  Apis.getPayoutSchemaValueOptionsForTransaction;
const API_FOR_KYC_OVERRIDE_CHECK = Apis.overrideCheckForKYC;
const API_FOR_LIVENESS_OVERRIDE_CHECK = Apis.overrideCheckForLiveness;
const API_FOR_SANCTION_OVERRIDE_CHECK = Apis.overrideCheckForSanction;
const API_FOR_OVERRIDE_SAR_RISK_CHECK_URL = Apis.overrideCheckForSarRisk;
const API_FOR_UPLOAD_DOCUMENTS_BY_URL = Apis.documentUploadForTransactionStep;
const API_FOR_DOCUMENTS_SHOW_BY_TRANSACTION_STEP_ID_URL =
  Apis.documentShowByTransactionStepId;
const API_FOR_FILE_EXTENSION_URL = Apis.fileExtension;
const API_FOR_GET_TRANSACTION_REPORT_URL = Apis.getTransactionReport;
const API_FOR_GET_TRANSACTION_REPORT_BY_TEMPLATE_ID_URL =
  Apis.getTransactionReportByCustomTemplate;
const API_FOR_GET_NECESSARY_TRANSACTION_URL =
  Apis.getNecessaryDetailsForTransaction;
const API_CUSTOMER_USER_URL = Apis.getCustomerUserList;
const API_RECEIVER_URL = Apis.getReceiverList;
const API_RECEIVER_USER_BY_ID_URL = Apis.receiverbyId;
const API_FOR_PROCESS_TO_RETURN_INITIATED_TRANSACTION_URL =
  Apis.processToReturnInitiated;
const API_FOR_PROCESS_TO_RETURN_COMPLETE_TRANSACTION_URL =
  Apis.processToReturnComplete;
const API_FOR_PROCESS_TO_RETURN_REJECT_TRANSACTION_URL =
  Apis.processToReturnReject;
const API_FOR_PROCESS_TO_RETURN_FAIL_TRANSACTION_URL = Apis.processToReturnFail;
const API_MODE_OF_PAYMENT_OR_PAYOUT_URL = Apis.modeOfPaymentOrPayout;
const API_APPROVE_RISK_CHECK_FROM_FLAGGED_URL = Apis.approveRiskCheck;
const API_CHECK_BALANCE_AT_PROVIDERS_END_URL = Apis.checkBalanceAtProvidersEnd;


const API_Limit = environment.dataLimit;
@Injectable({
  providedIn: 'root',
})
export class TransactionService implements OnDestroy {
  ingressCountriesCache: { url: string; data: any[] }[] = [];
  ingressCountriesListSubject = new BehaviorSubject<any[]>([]);

  egressCountriesCache: { url: string; data: any[] }[] = [];
  egressCountriesListSubject = new BehaviorSubject<any[]>([]);

  payoutOptionsCache: { url: string; data: any[] }[] = [];
  payoutOptionsListSubject = new BehaviorSubject<any[]>([]);

  paymentOptionsCache: { url: string; data: any[] }[] = [];
  paymentOptionsListSubject = new BehaviorSubject<any[]>([]);

  customerCache: { url: string; data: any[] }[] = [];
  customerListSubject = new BehaviorSubject<any[]>([]);

  receiverCache: { url: string; data: any[] }[] = [];
  receiverListSubject = new BehaviorSubject<any[]>([]);

  receiverByIdCache: { url: string; data: any[] }[] = [];
  receiverListByIdSubject = new BehaviorSubject<any[]>([]);

  fieldSchemaValueCache: { url: string; data: any[] }[] = [];
  fieldSchemaValueListSubject = new BehaviorSubject<any[]>([]);

  countryByCustomerCache: { url: string; data: any[] }[] = [];
  countryByCustomerListSubject = new BehaviorSubject<any[]>([]);

  constructor(private http: HttpClient) {}

  getTransactions(
    formOp: any = '',
    offsetToken: string = '',
    searchTerm: any = null
  ): Observable<any> {
    let baseURL = `${API_FOR_TRANSACTION_LIST_URL}?limit=${API_Limit}`;
    if (Object.keys(formOp).length > 0) {
      let urlParameters = Object.entries(formOp)
        .map((e) => e.join('='))
        .join('&');
      baseURL = `${baseURL}&${urlParameters}`;
    }
    if (offsetToken) {
      baseURL = `${baseURL}&offsetToken=${offsetToken}`;
    }
    if (searchTerm) {
      baseURL = `${baseURL}&queryString=${searchTerm}`;
    }
    return this.http.get<any>(baseURL);
  }

  getTransactionById(
    transactionId: any = '',
    header: any = false
  ): Observable<any> {
    let baseURL = `${API_FOR_TRANSACTIONS_BY_ID_URL}`;
    if (header) {
      return this.http.get<any>(`${baseURL}/${transactionId}`, {
        headers: new HttpHeaders({
          'Skip-Loader': 'true',
        }),
      });
    } else {
      return this.http.get<any>(`${baseURL}/${transactionId}`);
    }
  }

  getEstimate(data: any): Observable<GenericListResponse<any>> {
    return this.http.post<GenericListResponse<any>>(
      `${API_ESTIMATE_FOR_TRANSACTION_URL}`,
      data,
      {
        headers: new HttpHeaders({
          'Skip-Loader': 'true',
        }),
      }
    );
  }

  getIngressCountriesAvailableTransaction(formOp: any = ''): Observable<any> {
    let baseURL = `${API_INGRESS_COUNTRIES_FOR_TRANSACTION_URL}?limit=${API_Limit}`;
    if (Object.keys(formOp).length > 0) {
      let urlParameters = Object.entries(formOp)
        .map((e) => e.join('='))
        .join('&');
      baseURL = `${baseURL}&${urlParameters}`;
    }
    const cachedEntry = this.ingressCountriesCache.find((entry) =>
      this.areUrlsEqual(entry.url, baseURL)
    );

    if (cachedEntry) {
      this.ingressCountriesListSubject.next(cachedEntry.data);
      return of(cachedEntry.data);
    }
    return this.http
      .get<any>(baseURL, {
        headers: new HttpHeaders({
          'Skip-Loader': 'true',
        }),
      })
      .pipe(
        tap((res) => {
          const data = res?.data || [];
          this.ingressCountriesCache.push({ url: baseURL, data });
          this.ingressCountriesListSubject.next(data);
        }),
        map((res) => res?.data || [])
      );
  }

  getEgressCountriesAvailableTransaction(formOp: any = ''): Observable<any> {
    let baseURL = `${API_EGRESS_COUNTRIES_FOR_TRANSACTION_URL}?limit=${API_Limit}`;
    if (Object.keys(formOp).length > 0) {
      let urlParameters = Object.entries(formOp)
        .map((e) => e.join('='))
        .join('&');
      baseURL = `${baseURL}&${urlParameters}`;
    }
    const cachedEntry = this.egressCountriesCache.find((entry) =>
      this.areUrlsEqual(entry.url, baseURL)
    );

    if (cachedEntry) {
      this.egressCountriesListSubject.next(cachedEntry.data);
      return of(cachedEntry.data);
    }
    return this.http
      .get<any>(baseURL, {
        headers: new HttpHeaders({
          'Skip-Loader': 'true',
        }),
      })
      .pipe(
        tap((res) => {
          const data = res?.data || [];
          this.egressCountriesCache.push({ url: baseURL, data });
          this.egressCountriesListSubject.next(data);
        }),
        map((res) => res?.data || [])
      );
  }

  getIngressCurrenciesAvailableTransaction(formOp: any = ''): Observable<any> {
    let baseURL = `${API_INGRESS_CURRENCIES_FOR_TRANSACTION_URL}?limit=${API_Limit}`;
    if (Object.keys(formOp).length > 0) {
      let urlParameters = Object.entries(formOp)
        .map((e) => e.join('='))
        .join('&');
      baseURL = `${baseURL}&${urlParameters}`;
    }
    return this.http.get<any>(baseURL, {
      headers: new HttpHeaders({
        'Skip-Loader': 'true',
      }),
    });
  }

  getEgressCurrenciesAvailableTransaction(formOp: any = ''): Observable<any> {
    let baseURL = `${API_EGRESS_CURRENCIES_FOR_TRANSACTION_URL}?limit=${API_Limit}`;
    if (Object.keys(formOp).length > 0) {
      let urlParameters = Object.entries(formOp)
        .map((e) => e.join('='))
        .join('&');
      baseURL = `${baseURL}&${urlParameters}`;
    }
    return this.http.get<any>(baseURL, {
      headers: new HttpHeaders({
        'Skip-Loader': 'true',
      }),
    });
  }

  getPayoutOptionsForTransaction(formOp: any = ''): Observable<any> {
    let baseURL = `${API_PAYOUT_OPTION_FOR_TRANSACTION_URL}?limit=${API_Limit}`;
    if (Object.keys(formOp).length > 0) {
      let urlParameters = Object.entries(formOp)
        .map((e) => e.join('='))
        .join('&');
      baseURL = `${baseURL}&${urlParameters}`;
    }
    const cachedEntry = this.payoutOptionsCache.find((entry) =>
      this.areUrlsEqual(entry.url, baseURL)
    );

    if (cachedEntry) {
      this.payoutOptionsListSubject.next(cachedEntry.data);
      return of(cachedEntry.data);
    }
    return this.http
      .get<any>(baseURL, {
        headers: new HttpHeaders({
          'Skip-Loader': 'true',
        }),
      })
      .pipe(
        tap((res) => {
          const data = res?.data || [];
          this.payoutOptionsCache.push({ url: baseURL, data });
          this.payoutOptionsListSubject.next(data);
        }),
        map((res) => res?.data || [])
      );
  }

  getPaymentOptionsForTransaction(formOp: any = ''): Observable<any> {
    let baseURL = `${API_PAYMENT_OPTION_FOR_TRANSACTION_URL}?limit=${API_Limit}`;
    if (Object.keys(formOp).length > 0) {
      let urlParameters = Object.entries(formOp)
        .map((e) => e.join('='))
        .join('&');
      baseURL = `${baseURL}&${urlParameters}`;
    }
    const cachedEntry = this.paymentOptionsCache.find((entry) =>
      this.areUrlsEqual(entry.url, baseURL)
    );

    if (cachedEntry) {
      this.paymentOptionsListSubject.next(cachedEntry.data);
      return of(cachedEntry.data);
    }
    return this.http
      .get<any>(baseURL, {
        headers: new HttpHeaders({
          'Skip-Loader': 'true',
        }),
      })
      .pipe(
        tap((res) => {
          const data = res?.data || [];
          this.paymentOptionsCache.push({ url: baseURL, data });
          this.paymentOptionsListSubject.next(data);
        }),
        map((res) => res?.data || [])
      );
  }

  getCustomer(
    formOp: any = '',
    searchTerm: any = null,
    customerUserId: any = null,
    customerProfileType: any = null,
    wantWithoutOrderData: boolean = true
  ): Observable<any> {
    let baseURL = `${API_CUSTOMER_USER_URL}?limit=${API_Limit}`;
    if (Object.keys(formOp).length > 0) {
      let urlParameters = Object.entries(formOp)
        .map((e) => e.join('='))
        .join('&');
      baseURL = `${baseURL}&${urlParameters}`;
    }
    if (searchTerm) {
      baseURL = `${baseURL}&queryString=${searchTerm}`;
    }
    if (customerUserId) {
      baseURL = `${baseURL}&customerUserId=${customerUserId}`;
    }
    if (customerProfileType) {
      baseURL = `${baseURL}&customerProfileType=${customerProfileType}`;
    }
    if (!customerUserId) {
      baseURL = `${baseURL}&wantWithoutOrderData=${wantWithoutOrderData}`;
    }
    const cachedEntry = this.customerCache.find((entry) =>
      this.areUrlsEqual(entry.url, baseURL)
    );

    if (cachedEntry) {
      this.customerListSubject.next(cachedEntry.data);
      return of(cachedEntry.data);
    }
    return this.http
      .get<any>(`${baseURL}`, {
        headers: new HttpHeaders({
          'Skip-Loader': 'true',
        }),
      })
      .pipe(
        tap((res) => {
          const data = res?.data || [];
          this.customerCache.push({ url: baseURL, data });
          this.customerListSubject.next(data);
        }),
        map((res) => res?.data || [])
      );
  }

  getAllReceiver(
    formOp: any = '',
    offsetToken: string = '',
    searchTerm: any = null
  ): Observable<any> {
    let baseURL = `${API_RECEIVER_URL}?limit=${API_Limit}`;
    if (Object.keys(formOp).length > 0) {
      let urlParameters = Object.entries(formOp)
        .map((e) => e.join('='))
        .join('&');
      baseURL = `${baseURL}&${urlParameters}`;
    }
    if (offsetToken) {
      baseURL = `${baseURL}&offsetToken=${offsetToken}`;
    }
    if (searchTerm) {
      baseURL = `${baseURL}&queryString=${searchTerm}`;
    }
    const cachedEntry = this.receiverCache.find((entry) =>
      this.areUrlsEqual(entry.url, baseURL)
    );

    if (cachedEntry) {
      this.receiverListSubject.next(cachedEntry.data);
      return of(cachedEntry.data);
    }
    return this.http
      .get<any>(`${baseURL}`, {
        headers: new HttpHeaders({
          'Skip-Loader': 'true',
        }),
      })
      .pipe(
        tap((res) => {
          const data = res || '';
          this.receiverCache.push({ url: baseURL, data });
          this.receiverListSubject.next(data);
        }),
        map((res) => res || '')
      );
  }

  getReceiverById(receiverId: any = ''): Observable<any> {
    let baseURL = `${API_RECEIVER_USER_BY_ID_URL}/${receiverId}`;
    const cachedEntry = this.receiverByIdCache.find((entry) =>
      this.areUrlsEqual(entry.url, baseURL)
    );

    if (cachedEntry) {
      this.receiverListByIdSubject.next(cachedEntry.data);
      return of(cachedEntry.data);
    }
    return this.http
      .get<any>(`${baseURL}`, {
        headers: new HttpHeaders({
          'Skip-Loader': 'true',
        }),
      })
      .pipe(
        tap((res) => {
          const data = res || '';
          this.receiverByIdCache.push({ url: baseURL, data });
          this.receiverListByIdSubject.next(data);
        }),
        map((res) => res || '')
      );
  }

  createTransaction(data: any): Observable<any> {
    return this.http.post<any>(`${API_FOR_CREATE_TRANSACTION_URL}`, data);
  }

  getCountryByCustomerId(customerId: any): Observable<any> {
    let baseURL = `${API_FOR_CUSTOMER_BY_ID_URL}/${customerId}`;

    const cachedEntry = this.countryByCustomerCache.find((entry) =>
      this.areUrlsEqual(entry.url, baseURL)
    );

    if (cachedEntry) {
      this.countryByCustomerListSubject.next(cachedEntry.data);
      return of(cachedEntry.data);
    }
    return this.http
      .get<any>(`${baseURL}`, {
        headers: new HttpHeaders({
          'Skip-Loader': 'true',
        }),
      })
      .pipe(
        tap((res) => {
          const data = res || '';
          this.countryByCustomerCache.push({ url: baseURL, data });
          this.countryByCustomerListSubject.next(data);
        }),
        map((res) => res || '')
      );
  }

  getTransactionStepsByTransactionId(transactionId: any): Observable<any> {
    let baseURL = `${API_FOR_TRANSACTION_STEPS_BY_TRANSACTION_ID_URL}`;
    return this.http.get<any>(`${baseURL}/${transactionId}`, {
      headers: new HttpHeaders({
        'Skip-Loader': 'true',
      }),
    });
  }

  getActionForTransaction(
    transactionId: any,
    header: any = false
  ): Observable<any> {
    let baseURL = `${API_FOR_ACTION_FOR_TRANSACTION_URL}`;
    if (header) {
      return this.http.get<any>(`${baseURL}/${transactionId}`, {
        headers: new HttpHeaders({
          'Skip-Loader': 'true',
        }),
      });
    } else {
      return this.http.get<any>(`${baseURL}/${transactionId}`);
    }
  }

  getLinkForLiveness(transactionId: any): Observable<any> {
    let baseURL = `${API_FOR_LINK_FOR_LIVENESS_URL}`;
    return this.http.get<any>(`${baseURL}?transactionId=${transactionId}`);
  }

  skipLiveness(transactionId: string, comment: string): Observable<any> {
    let baseURL = `${API_FOR_SKIP_LIVENESS_URL}`;
    return this.http.post<any>(baseURL, { transactionId, comment });
  }

  initSanctionCheck(transactionId: any): Observable<any> {
    let baseURL = `${API_FOR_INIT_SANCTION_CHECK_URL}`;
    return this.http.get<any>(`${baseURL}?transactionId=${transactionId}`);
  }

  getPaymentLink(transactionId: any): Observable<any> {
    let baseURL = `${API_FOR_INIT_PAYMENT_URL}`;
    return this.http.post<any>(`${baseURL}`, {
      transactionId: transactionId,
    });
  }

  paymentDone(transactionId: any): Observable<any> {
    let baseURL = `${API_FOR_PAYMENT_DONE_URL}`;
    return this.http.post<any>(`${baseURL}`, {
      transactionId: transactionId,
    });
  }

  processedToPayoutInProgress(transactionId: any): Observable<any> {
    let baseURL = `${API_FOR_PROCESSED_TO_PAYOUT_INPROGRESS_URL}`;
    return this.http.post<any>(`${baseURL}`, {
      transactionId: transactionId,
    });
  }

  processedToPayoutComplete(transactionId: any): Observable<any> {
    let baseURL = `${API_FOR_PROCESSED_TO_PAYOUT_COMPLETE_URL}`;
    return this.http.post<any>(`${baseURL}`, {
      transactionId: transactionId,
    });
  }

  getPurposes(): Observable<any> {
    let baseURL = `${API_FOR_PURPOSES_URL}`;
    return this.http.get<any>(`${baseURL}`);
  }

  getSARTransactionById(transactionId: any): Observable<any> {
    let baseURL = `${API_FOR_SAR_TRANSACTION_BY_ID_URL}`;
    return this.http.get<any>(`${baseURL}/${transactionId}`);
  }

  getPublicIP(): Promise<string> {
    return fetch('https://api.ipify.org?format=json')
      .then((res) => res.json())
      .then((data) => data.ip);
  }

  async getFingerprint(): Promise<any> {
    const fp = await FingerprintJS.load();
    const result = await fp.get();

    return {
      visitorId: result.visitorId,
      userAgent: navigator.userAgent,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      platform: navigator.platform,
      language: navigator.language,
      timezone: new Date().getTimezoneOffset(),
      // Add more if needed from `result.components`
    };
  }

  downloadTransactionDocument(
    transactionId: string,
    documentId: string
  ): Observable<any> {
    let baseURL = `${API_FOR_PUBLIC_URL_TRANSACTION_DOCUMENT}`;
    return this.http.get<any>(`${baseURL}/${transactionId}/${documentId}`);
  }

  getSharableLinkForTransactionMiscVars(
    transactionId: string,
    refId: string
  ): Observable<any> {
    let baseURL = `${API_FOR_TRANSACTION_MISC_VAR_SHAREABLE_LINK}`;
    return this.http.get<any>(`${baseURL}/${transactionId}/${refId}`);
  }

  getPayoutSchemaValueOptionsForTransaction(
    customerId: string,
    modeOfPayout: string
  ): Observable<any> {
    let queryObj = new URLSearchParams({
      egressCustomerId: customerId,
      modeOfPayOut: modeOfPayout,
    });
    let baseURL = `${API_FOR_TRANSACTION_PAYOUT_SCHEMA_VALUE_OPTION}?${queryObj.toString()}`;
    const cachedEntry = this.fieldSchemaValueCache.find((entry) =>
      this.areUrlsEqual(entry.url, baseURL)
    );

    if (cachedEntry) {
      this.fieldSchemaValueListSubject.next(cachedEntry.data);
      return of(cachedEntry.data);
    }
    return this.http
      .get<any>(baseURL, {
        headers: new HttpHeaders({
          'Skip-Loader': 'true',
        }),
      })
      .pipe(
        tap((res) => {
          const data = res?.data || [];
          this.fieldSchemaValueCache.push({ url: baseURL, data });
          this.fieldSchemaValueListSubject.next(data);
        }),
        map((res) => res?.data || [])
      );
  }

  performOverrideCheck(transactionId: any, type: string = ''): Observable<any> {
    let baseURL = '';
    if (type == 'kyc') {
      baseURL = `${API_FOR_KYC_OVERRIDE_CHECK}`;
    } else if (type == 'liveness') {
      baseURL = `${API_FOR_LIVENESS_OVERRIDE_CHECK}`;
    } else if (type == 'sanction') {
      baseURL = `${API_FOR_SANCTION_OVERRIDE_CHECK}`;
    }
    return this.http.post<any>(`${baseURL}`, {
      transactionId: transactionId,
    });
  }

  overrideSarRiskCheck(transactionId: any, comment: any): Observable<any> {
    let baseURL = `${API_FOR_OVERRIDE_SAR_RISK_CHECK_URL}`;

    return this.http.post<any>(`${baseURL}`, {
      transactionId: transactionId,
      comment: comment,
    });
  }

  uploadDocument(
    fileNames: any[] = [],
    transactionStepId: any,
    comment: any
  ): Observable<any> {
    let baseURL = `${API_FOR_UPLOAD_DOCUMENTS_BY_URL}`;
    return this.http.post<any>(`${baseURL}`, {
      transactionStepId: transactionStepId,
      comment: comment,
      fileInfo: fileNames,
    });
  }

  getDocumentIdByTransactionStepId(
    transactionStepId: any,
    documentId: any
  ): Observable<any> {
    let baseURL = `${API_FOR_DOCUMENTS_SHOW_BY_TRANSACTION_STEP_ID_URL}/${transactionStepId}/${documentId}`;
    return this.http.get<any>(`${baseURL}`);
  }

  getFileExtension(): Observable<any> {
    let baseURL = `${API_FOR_FILE_EXTENSION_URL}`;
    return this.http.get<any>(`${baseURL}`);
  }

  getDownloadTransactions(
    formOp: any = '',
    fileExtension: any = ''
  ): Observable<GenericListResponse<any>> {
    let baseURL = '';
    baseURL = `${API_FOR_GET_TRANSACTION_REPORT_URL}/${fileExtension}`;
    if (Object.keys(formOp).length > 0) {
      let urlParameters = Object.entries(formOp)
        .map((e) => e.join('='))
        .join('&');
      baseURL = `${baseURL}?${urlParameters}`;
    }
    return this.http.get<any>(baseURL);
  }

  getTransactionReportByTemplateId(
    formOp: any = '',
    templateId: any
  ): Observable<GenericListResponse<any>> {
    let baseURL = '';
    baseURL = `${API_FOR_GET_TRANSACTION_REPORT_BY_TEMPLATE_ID_URL}/${templateId}`;
    if (Object.keys(formOp).length > 0) {
      let urlParameters = Object.entries(formOp)
        .map((e) => e.join('='))
        .join('&');
      baseURL = `${baseURL}?${urlParameters}`;
    }
    return this.http.get<any>(baseURL);
  }

  getNecessaryDetails(transactionIdOrCode: any): Observable<any> {
    let baseURL = `${API_FOR_GET_NECESSARY_TRANSACTION_URL}/${transactionIdOrCode}`;
    return this.http.get<any>(baseURL);
  }

  processToReturnInitiated(transactionId: any): Observable<any> {
    let baseURL = `${API_FOR_PROCESS_TO_RETURN_INITIATED_TRANSACTION_URL}`;
    return this.http.post<any>(baseURL, {
      transactionId: transactionId,
    });
  }

  processToReturnComplete(transactionId: any): Observable<any> {
    let baseURL = `${API_FOR_PROCESS_TO_RETURN_COMPLETE_TRANSACTION_URL}`;
    return this.http.post<any>(baseURL, {
      transactionId: transactionId,
    });
  }

  processToReturnReject(transactionId: any): Observable<any> {
    let baseURL = `${API_FOR_PROCESS_TO_RETURN_REJECT_TRANSACTION_URL}`;
    return this.http.post<any>(baseURL, {
      transactionId: transactionId,
    });
  }

  processToReturnFail(transactionId: any): Observable<any> {
    let baseURL = `${API_FOR_PROCESS_TO_RETURN_FAIL_TRANSACTION_URL}`;
    return this.http.post<any>(baseURL, {
      transactionId: transactionId,
    });
  }

  approveRiskCheck(data: any): Observable<any> {
    let baseURL = `${API_APPROVE_RISK_CHECK_FROM_FLAGGED_URL}`;
    return this.http.post<any>(baseURL, data);
  }

  areUrlsEqual(currentUrl: string, storedUrl: string): boolean {
    try {
      const u1 = new URL(currentUrl);
      const u2 = new URL(storedUrl);

      // Compare base parts
      if (u1.origin + u1.pathname !== u2.origin + u2.pathname) {
        return false;
      }

      // Compare search params regardless of order
      const params1 = new URLSearchParams(u1.search);
      const params2 = new URLSearchParams(u2.search);

      return params1.toString() === params2.toString();
    } catch {
      return false;
    }
  }

  getModeOfPaymentOrPayout(): Observable<any> {
    return this.http.get<TokenAndRefreshToken>(
      API_MODE_OF_PAYMENT_OR_PAYOUT_URL
    );
  }

  getCheckBalanceAtProvidersEnd(transactionId: any): Observable<any> {
    let baseURL = `${API_CHECK_BALANCE_AT_PROVIDERS_END_URL}`;
    return this.http.get<any>(`${baseURL}/${transactionId}`);
  }

  ngOnDestroy() {}
}
